import React from 'react'

export default function GuestCheckoutInfo({cancel, proceed}) {
  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center" style={{maxWidth: '800px'}}>
                <h2>Enable Guest Checkout</h2>

                <div className="text-left">
                    Guest checkout enables frictionless sponsorships by collecting only essential Stripe payment data—bypassing account creation and internal notifications while requiring all ongoing subscription management to be handled directly within the Stripe dashboard.
                </div>

                <div className="pt-3">
                    <button onClick={proceed} type="button" className="btn btn-primary mr-2">
                        Proceed
                    </button>

                    <button onClick={cancel} type="button" className="btn btn-danger mr-2">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
